import { render, staticRenderFns } from "./NewClassStu.vue?vue&type=template&id=25048898&scoped=true&"
import script from "./NewClassStu.vue?vue&type=script&lang=js&"
export * from "./NewClassStu.vue?vue&type=script&lang=js&"
import style0 from "./NewClassStu.vue?vue&type=style&index=0&id=25048898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25048898",
  null
  
)

export default component.exports